import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";

const connectivityPageTplData = (id) => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            template {
                                ... on WpTemplate_Connectivity {
                                    connectivityRichContent {
                                        # SECTION: Hero
                                        hero {
                                            category
                                            header
                                            secondHeader
                                            text
                                            buttons {
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                            image {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                            backgroundImage {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                        # SECTION: Page Header
                                        pageHeader {
                                            title
                                            text
                                            types {
                                                header
                                                item {
                                                    text
                                                }
                                            }
                                }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                    }
                }
            }
                                        }
                                }
`
    );

    return getCurrentRichContent(data, id, "connectivityRichContent");
};

export { connectivityPageTplData };
